export function register() {
  console.log("Registrando service worker", navigator)
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      navigator.serviceWorker.register(swUrl)
        .then((registration) => {
          console.log('Service worker registrado com sucesso!', registration);
        })
        .catch((error) => {
          console.error('Erro durante o registro do service worker:', error);
        });
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    // Desregistrar TODOS os service workers
    navigator.serviceWorker.getRegistrations().then(function(registrations) {
      for(let registration of registrations) {
        console.log('🗑️ Removendo SW:', registration.scope);
        registration.unregister().then(function(boolean) {
          console.log('✅ SW removido:', boolean);
        });
      }
    });

    // Limpar cache do navegador também
    if ('caches' in window) {
      caches.keys().then(function(names) {
        for(let name of names) {
          console.log('🗑️ Removendo cache:', name);
          caches.delete(name);
        }
      });
    }
  }
}
